module.exports = __webpack_public_path__ + "static/media/img_7.f0c096e1.JPG";